import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { DataModelClass, DataModel } from "src/formBuilder/datamodel/structure";
import { NoMediaTemplateViewModel, TemplateViewModel } from "../templateList-viewModel";
import  { TemplateCreatorView } from "./templateCreator-view"

export class TemplateCreatorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.classes = ObservableArray.create<DataModelClass>();        

    }
    closePopup(result: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new TemplateCreatorView();
    }
    public getTypeId(): string {
        return "VM-4271AF41-9964-4833-A94E-91E42AEE3D32"
    }

    
    public set newName(v: string) { this._newName = v; } public get newName(): string { return this._newName;} private _newName: string;
    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;
    public set selectedClass(v: DataModelClass) { this._selectedClass = v; } public get selectedClass(): DataModelClass { return this._selectedClass;} private _selectedClass: DataModelClass;
    private templateParent :ViewModel;

    loadInfo(templateParent:ViewModel, dataModel : DataModel){
        this.templateParent = templateParent;
        this.classes.update(...dataModel.classes);
        this.newName = "";
    }

    create(){
        let template = new NoMediaTemplateViewModel(this.templateParent);
        template.name = this.newName;
        template.dataModelClass = this.selectedClass;
        this.closePopup(template);
    }

    back(){
        this.closePopup(null);
    }
}
